/*
=========================================================
* Material Kit 2 PRO React - v2.1.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 PRO React examples
import HorizontalTeamCard from "examples/Cards/TeamCards/HorizontalTeamCard";

// Images
import team1 from "assets/images/diretores/Renan.jpeg";
import team2 from "assets/images/diretores/Mazzini.jpeg";
import team3 from "assets/images/diretores/blank.png";
import team4 from "assets/images/diretores/Celina.jpeg";
import team5 from "assets/images/diretores/Frederico.jpeg";

function Team() {
  return (
    <MKBox
      component="section"
      variant="gradient"
      bgColor="dark"
      position="relative"
      py={6}
      px={{ xs: 2, lg: 0 }}
      mx={-2}
    >
      <Container>
        <Grid container>
          <Grid item xs={12} md={8} sx={{ mb: 6 }}>
            <MKTypography variant="h3" color="white">
              Nosso Time Executivo
            </MKTypography>
            <MKTypography variant="body2" color="white" opacity={0.8}>
              Nossa equipe de direcao.

            </MKTypography>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={6}>
            <MKBox mb={1}>
              <HorizontalTeamCard
                image={team1}
                name="Renan Fenelon"
                position={{ color: "info", label: "Diretor Executivo" }}
                description="Engenheiro eletrônico, aviador e fundador. Traz consigo duas décadas em TI e foco em segurança da informação."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={1}>
              <HorizontalTeamCard
                image={team2}
                name="Odilon Mazzini"
                position={{ color: "info", label: "Diretor de Operações" }}
                description="Coronel, Doutor e fundador. Traz consigo quatro décadas de serviço ao exército do brasileiro e ao governo federal."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={{ xs: 1, lg: 0 }}>
              <HorizontalTeamCard
                image={team3}
                name="CTO"
                position={{ color: "info", label: "Diretor de TI" }}
                description=""
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={{ xs: 1, lg: 0 }}>
              <HorizontalTeamCard
                image={team4}
                name="Celina Ladeira"
                position={{ color: "info", label: "Diretora de Relacionamentos" }}
                description="Administradora, designer e a melhor pessoa que alguém pode ter a sorte de conhecer."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={{ xs: 1, lg: 0 }}>
              <HorizontalTeamCard
                image={team5}
                name="Frederico Nonato Parreira"
                position={{ color: "info", label: "Diretor Jurídico" }}
                description="Excepcional advogado com mais de 30 anos de experiência em grandes empresas de tecnologia."
              />
            </MKBox>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Team;
